module.exports = __webpack_public_path__ + "img/dny.0a086d88.png";